// @ts-check
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, reset, formValueSelector } from 'utils/reduxFormWrapper';
import api from 'utils/api';
import { flashSuccess } from 'shared/actions/UnboundFlashMessageActions';
import HForm, { SelectField } from 'shared/containers/portal_layout/HForm';
import { required } from 'utils/validation';
import SpinnerButton from 'shared/components/SpinnerButton';
import LoadingContent from 'shared/components/LoadingContent';

class _AssignAgentForm extends Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.fetchAgents = this.fetchAgents.bind(this);
    this.state = {
      loading: true,
      agents: null,
      error: null,
    };
  }

  componentDidMount() {
    this.fetchAgents(this.props.referralId);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.referralId !== this.props.referralId) {
      this.fetchAgents(this.props.referralId);
    }
  }

  fetchAgents(referralId) {
    const { apiEndpoint } = this.props;
    this.setState({ loading: true });
    api.get(`${apiEndpoint}/referrals/${referralId}/available_agents`).then(resp => {
      this.setState({
        loading: false,
        agents: resp.data.agents,
        error: null,
      });
    });
  }

  submit(formValues) {
    const { apiEndpoint, referralId } = this.props;
    return api
      .put(`${apiEndpoint}/referrals/${referralId}/assigned_agent`, {
        agent_id: formValues.assignedAgentId,
      })
      .then(resp => {
        this.props.dispatch(flashSuccess({ message: 'Referral updated.' }));
        this.props.handleSuccess();
        this.props.dispatch(reset('assignedAgent'));
        return null;
      });
  }

  render() {
    const { submitting } = this.props;
    const { loading, error, agents } = this.state;

    return (
      <HForm onSubmit={this.props.handleSubmit(this.submit)}>
        <div className="modal-header">
          <h3>Assign Referral</h3>
        </div>
        <div className="modal-body" style={{ width: 600 }}>
          {loading ? (
            <LoadingContent />
          ) : error ? (
            <p>Failed to load.</p>
          ) : (
            <SelectField
              name="assignedAgentId"
              label="Assign to:"
              options={agents || []}
              labelKey="name"
              valueKey="id"
              validate={required}
            />
          )}
        </div>
        <div className="modal-footer">
          <SpinnerButton
            className="btn btn-primary"
            type="submit"
            disabled={loading}
            loading={submitting}
          >
            Assign Referral
          </SpinnerButton>
        </div>
      </HForm>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const assignedAgentId = formValueSelector(ownProps.form)(state, 'assignAgent');
  return {
    assignedAgentId,
  };
};

const AssignAgentForm = reduxForm({ form: 'assignAgent' })(
  connect(mapStateToProps)(_AssignAgentForm)
);

export { AssignAgentForm };
